// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1025dce8] .el-dialog__body{padding:30px 20px!important}", ""]);
// Exports
module.exports = exports;
